import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Avisa a las demás pestañas de que las órdenes de una cartera cambiaron (p. ej. se cancelaron
 * desde /broker-operations), para que /broker → Órdenes vuelva a leer la BD sin esperar al polling.
 *
 * BroadcastChannel solo entrega a OTRAS instancias, así que la pestaña que emite no se recarga a sí misma.
 */
@Injectable({
  providedIn: 'root'
})
export class OrdenesSyncService implements OnDestroy {
  private readonly CHANNEL_NAME = 'broker-ordenes-channel';
  private channel: BroadcastChannel | null = null;
  private cambiosSubject = new Subject<string>();
  /** idcartera (como string) cuyas órdenes cambiaron en otra pestaña */
  public cambios$: Observable<string> = this.cambiosSubject.asObservable();

  constructor(private zone: NgZone) {
    if (typeof BroadcastChannel === 'undefined') return;
    this.channel = new BroadcastChannel(this.CHANNEL_NAME);
    this.channel.onmessage = (event) => {
      if (event.data?.type !== 'ordenes-actualizadas') return;
      this.zone.run(() => this.cambiosSubject.next(String(event.data.idcartera)));
    };
  }

  notificarCambio(idcartera: string | number): void {
    this.channel?.postMessage({ type: 'ordenes-actualizadas', idcartera: String(idcartera), ts: Date.now() });
  }

  ngOnDestroy(): void {
    this.channel?.close();
  }
}
